import useFormatDateTime from "../useFormatDateTime/useFormatDateTime";
import { useFormatCompactDate } from "./useFormatCompactDate";
import { FormatDateParams, FormatDateOptions, FormatIntlOptionsMap, AnyDate } from "./useFormatDate.types";

export const FORMAT_INTL_OPTIONS_MAP: FormatIntlOptionsMap = {
    slashed: {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    },
    dashed: {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    },
    compact: {
        hour: "2-digit",
        minute: "2-digit",
    },
};

/**
 * Hook to format a date.
 * - `slahed` - 12/12/2012
 * - `dashed` - 12-12-2012
 * - `compact` - Today, 18:20 | Yesterday, 18:20 | 12/12/2012, 18:20
 *
 * If you need more customization, use the hooks: `useFormatDateTime` or `useFormatRelativeTime` instead.
 */
export default function (
    formatDateOption: FormatDateOptions = "slashed",
): (date: AnyDate | undefined, params?: FormatDateParams) => string {
    const formateDate = useFormatDateTime();
    const formateCompactDate = useFormatCompactDate();

    const finalFormatDate = (date: AnyDate | undefined, { format = formatDateOption }: FormatDateParams = {}) => {
        if (typeof date === "undefined") return "";
        if (typeof date === "string" && !isNaN(Number(date))) date = new Date(Number(date));
        if (format === "compact") return formateCompactDate(date);
        const formattedDate = formateDate(date, FORMAT_INTL_OPTIONS_MAP[format]);
        if (format === "slashed") return formattedDate;
        else return formattedDate.replace(/\//g, "-");
    };

    return finalFormatDate;
}
